import React from 'react';
import PropTypes from 'prop-types';

import { Title, Container, StyledInput, SubtitleList, SubtitleItem, SingleSubtitle } from './PassengerCountInput.styles';

const PassengerCountInput = ({ title, value, onChange, subtitles, maxCount }) => (
  <Container data-cy="passenger-count-input">
    <div>
      <Title>{title}</Title>

      {subtitles && subtitles.length === 1 && <SingleSubtitle>{subtitles[0]}</SingleSubtitle>}

      {subtitles && subtitles.length > 1 && (
        <SubtitleList>
          {subtitles.map((s, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <SubtitleItem key={index}>{s}</SubtitleItem>
          ))}
        </SubtitleList>
      )}
    </div>

    <StyledInput
      value={value}
      data-cy="passenger-count-input-field"
      data-testid="passenger-count-input-field"
      onChange={(event) => {
        const raw = event.target.value || '0';
        const number = parseInt(raw, 10);
        const withinRange = !maxCount || number <= maxCount;
        if (Number.isInteger(number) && withinRange && onChange) {
          onChange(number);
        }
      }}
      placeholder="0"
    />
  </Container>
);

PassengerCountInput.propTypes = {
  maxCount: PropTypes.number,
  onChange: PropTypes.func,
  subtitles: PropTypes.arrayOf(PropTypes.node),
  title: PropTypes.node,
  value: PropTypes.number.isRequired
};

export default PassengerCountInput;
